import { createIdSlice } from '../utils/action/createElementSlice';
export const AccessibilityLabelState = createIdSlice({
    elementName: 'accessibilityLabel',
    initialState: {},
    reducers: {
        set: (_state, action) => {
            return action.payload.data;
        },
    },
});
